import React from 'react'
import { Outlet } from 'react-router-dom'

const ExtensionActivities = () => {
  return (
    <div><Outlet /></div>
  )
}

export default ExtensionActivities